import { useAtomValue } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { useCallback, useMemo } from 'react';
import { assetAtom } from '../loader/cache';

const useAssetCache = () => useAtomValue(assetAtom)

export const useAsset = (key: string) => {
  return useAtomValue(selectAtom(assetAtom, useCallback((state) => state[key], [key])))
}


type Assets<T extends any[]> = { [I in keyof T]: T[number] };

export function useAssets<T extends string[]>(keys: [...T]) {
  const cache = useAssetCache()
  if(keys.some(k => !cache[k])) {
    throw new Error('Asset not found in cache.')
  }
  return keys.map((key) => {
    return cache[key]
  }) as Assets<T>
}


export default useAssetCache